import { Button, Checkbox, TableCell, TableRow } from "@mui/material";
import { types } from "api";
import { useAuthStatus } from "helpers/useAuthStatus";
import React from "react";

export interface ViewGroupsPageTableRowProps {
	selected: string[];
	handleClick: (event: React.MouseEvent<unknown>, userid: string) => void;
	handleDeleteOpen: (UUID: string) => void;
	row: types.UserBasic;
	labelId: string;
}

export const ViewGroupsPageTableRow = ({
	selected,
	row,
	handleClick,
	handleDeleteOpen,
	labelId,
}: ViewGroupsPageTableRowProps): JSX.Element => {
	const { role } = useAuthStatus();
	const isSelected = (userid: string): boolean =>
		selected.indexOf(userid) !== -1;

	const isItemSelected = isSelected(row.userId);

	return (
		<TableRow
			hover
			role="checkbox"
			aria-checked={isItemSelected}
			key={row.email}
			selected={isItemSelected}
		>
			<TableCell padding="checkbox">
				<Checkbox
					checked={isItemSelected}
					data-testid="checkbox"
					inputProps={{ "aria-labelledby": labelId }}
					onClick={(event) => handleClick(event, row.userId)}
				/>
			</TableCell>
			<TableCell align="left" data-testid="firstName">
				{row.firstName}
			</TableCell>
			<TableCell align="left" data-testid="lastName">
				{row.lastName}
			</TableCell>
			<TableCell align="left" data-testid="email">
				{row.email}
			</TableCell>
			{role !== "student" && (
				<TableCell align="left">
					<Button
						color="secondary"
						onClick={() => handleDeleteOpen(row.userId)}
					>
						DELETE
					</Button>
				</TableCell>
			)}
		</TableRow>
	);
};
